<template>
  <div class="question-box">
    <div class="question-title">
      <div v-html="questionContent.content"></div>
      <viewer :images="questionContent.file" class="question-title-imgbox" v-if="questionContent.file && questionContent.file.length">
        <img v-for="(src,index) in questionContent.file" :src="src.url" :key="index" class="option-img">
      </viewer>
    </div>
    <div v-for="(item,i) in optionsContent" :key="i">
      <div class="question-option" :class="{ active: multipleAnswer.indexOf(i) !== -1 }">
        <el-checkbox-group v-model="multipleAnswer">
          <el-checkbox :label="i">
            <span class="question-option-sort">{{optionMap[i]}}.</span>
            <span class="question-option-content">
              {{item.content}}
            </span>
          </el-checkbox>
        </el-checkbox-group>
      </div>
      <viewer :images="item.file" class="option-img-box">
        <img v-for="(src,index) in item.file" :src="src.url" :key="index" class="option-img">
      </viewer>
    </div>
  </div>
</template>

<script>
import { userSubmitTopicData } from '@/api/show'
export default {
  created() {

  },
  beforeDestroy() {
    if (!this.status) {
      this.answerPost();
    }
  },
  watch: {
    currentIndex: function () {
      this.initData()
    }
  },
  props: ['itemContent', 'index', 'currentIndex', 'status', 'recordId', 'replay_type'],
  data() {
    return {
      multipleAnswer: [],//多选答案
      answerCache: [],
      titleId: '',//试题id
      optionsContent: [],
      questionContent: {},//题干数据保存
      analysisContent: {},//解析数据保存
      optionMap: {
        0: 'A', 1: 'B', 2: 'C', 3: 'D', 4: 'E', 5: 'F', 6: 'G', 7: 'H', 8: 'I', 9: 'J',
      },
    }
  },
  mounted() {
    this.initData()
    let answer = sessionStorage.getItem('answer')
    if (answer !== '' && answer !== 'undefined') {
      answer = JSON.parse(answer)
      this.multipleAnswer = answer
      this.answerCache = [...answer]
    }
    window.onbeforeunload = e => {
      if (this.$route.fullPath === "/show/exercise") {
        e = e || window.event;
        if (e) {
          e.returnValue = "关闭提示";
        }
        // return "关闭提示";
      } else {
        window.onbeforeunload = null
      }
    };
  },
  methods: {
    initData: function () {
      this.multipleAnswer = []
      this.titleId = this.itemContent.id
      this.optionsContent = this.itemContent.answer
      this.questionContent = this.itemContent.topic_title
      this.analysisContent = this.itemContent.parsing
    },
    //提交答案
    answerPost: function () {
      let flag = true
      const result = this.answerCache.length === this.multipleAnswer.length && this.answerCache.every(a => this.multipleAnswer.some(b => a === b)) && this.multipleAnswer.every(_b => this.answerCache.some(_a => _a === _b));
      if (result) {
        flag = false
      }
      if (flag) {
        let info = JSON.parse(sessionStorage.getItem('paperInfo'))
        let params = {
          student_id: info.studentId,
          competition_id: info.competitionId,
          paper_id: info.paperId,
          title_id: this.titleId,
          title_type: 2,
          answer: this.multipleAnswer,
          record_id: this.recordId,
          replay_type: this.replay_type
        }
        userSubmitTopicData(params).then(response => {

        })
      }
      let obj = {
        type: 'multipleChoice',
        index: this.index,
        currentIndex: this.currentIndex,
        answer: this.multipleAnswer
      }
      this.$root.$emit('returnanswer', obj);
    }
  },
  filters: {
    capitalize: function (value) {
      if (!value && value != 0) return false;
      var arr = { 0: 'A', 1: 'B', 2: 'C', 3: 'D', 4: 'E', 5: 'F', 6: 'G', 7: 'H' }
      var str = '';
      for (var i = 0; i < value.length; i++) {
        str += ' ' + arr[value[i]] + ' '
      }
      return str
    }
  }
}
</script>

<style scoped="">
</style>